import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/+447862494152?text=Hello%2C%20I%20need%20help%20with%20my%20order."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-10 right-0 md:right-10 bg-green-600 text-white px-4 py-3 rounded-full w-52 shadow-md hover:bg-green-500 transition-colors duration-300 flex items-center space-x-3"
      style={{ zIndex: 1000 }}
    >
      <FontAwesomeIcon icon={faWhatsapp} className="text-white text-2xl" />
      <span>Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;




// // WhatsAppButton.js
// import React from 'react';

// const WhatsAppButton = () => {
//   return (
//     <a
//       href="https://wa.me/+07879052459?text=Hello%2C%20I%20need%20help%20with%20my%20order."
//       target="_blank"
//       rel="noopener noreferrer"
//       className="fixed bottom-60 right-5 bg-green-600 text-white p-3 md:p-4 rounded-full shadow-lg hover:bg-green-500 transition-colors duration-300 flex items-center justify-center"
//       style={{ zIndex: 1000 }}
//     >
//       <i className="fab fa-whatsapp text-white" style={{ fontSize: '30px' }}></i> {/* Font Awesome WhatsApp icon */}
//     </a>
//   );
// };

// export default WhatsAppButton;
